// extracted by mini-css-extract-plugin
export default {"tableBox":"p5wrSSSeDcOBSxQwPwJB"};